import {
  IonButton,
  IonButtons,
  IonCheckbox,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Category } from "../../../@types/Category";
import { setTypeFilter, setFilterByTypeModal } from "../../../store/documentsSignerList";
import { fetchDocuments } from "../../../store/documentsSignerList/actions/fetchDocuments";
import { selectFilterByTypeModal } from "../../../store/documentsSignerList/selectors/selectFilterByTypeModal";
import { selectTypeFilter } from "../../../store/documentsSignerList/selectors/selectTypeFilter";
import { selectDocumentCategory } from "../../../store/utils/selectors/selectDocumentCategory";

export const FilterTypeSelector: React.FC = () => {
  const dispatch = useDispatch();

  const allTypes = useSelector(selectDocumentCategory);
  const typeFilter = useSelector(selectTypeFilter);
  const showModal = useSelector(selectFilterByTypeModal);

  const [typeFormData, setTypeFormData] = useState<Category[]>([]);

  const initFormData = () => {
    setTypeFormData(
      allTypes.map((type) => ({
        ...type,
        checked: !!typeFilter?.find(({ id }) => id === type.id),
      }))
    );
  };

  const handleCheck = (typeChecked: Category) => {
    setTypeFormData(
      typeFormData.map((typeItem) => ({
        ...typeItem,
        checked: typeChecked.id === typeItem.id ? !typeItem.checked : typeItem.checked,
      }))
    );
  };

  const applyFilter = async () => {
    dispatch(setTypeFilter(typeFormData.filter(({ checked }) => checked)));
    dispatch(setFilterByTypeModal(false));
    dispatch(fetchDocuments());
  };

  const resetTypeFilter = () => {
    dispatch(setTypeFilter([]));
    dispatch(setFilterByTypeModal(false));
    dispatch(fetchDocuments());
  };

  return (
    <>
      <IonModal
        isOpen={showModal}
        onWillPresent={initFormData}
        onDidDismiss={() => dispatch(setFilterByTypeModal(false))}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Filtrar por tipo de documento</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => dispatch(setFilterByTypeModal(false))}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonList>
            <IonListHeader>Tipos de documento:</IonListHeader>
            {typeFormData.map((typeItem: Category, index: number) => (
              <IonItem key={index}>
                <IonLabel>{typeItem.name}</IonLabel>
                <IonCheckbox
                  slot="end"
                  checked={typeItem.checked}
                  onIonChange={() => handleCheck(typeItem)}
                />
              </IonItem>
            ))}
          </IonList>
        </IonContent>
        <IonFooter>
          <IonToolbar color="light">
            <IonButtons slot="end">
              <IonButton color="danger" fill="solid" onClick={resetTypeFilter}>
                Limpiar filtro
              </IonButton>
              <IonButton color="primary" fill="solid" onClick={applyFilter}>
                Aplicar filtro
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </IonModal>
    </>
  );
};
